// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 width=%2716%27 height=%2716%27%3e%3cg%3e%3cpolygon fill=%27%23A2AAB4%27 points=%2711.06 5.72666667 8 8.78 4.94 5.72666667 4 6.66666667 8 10.6666667 12 6.66666667%27%3e%3c/polygon%3e%3c/g%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-container.minimized .sidebar-shops {
  width: 2rem;
  padding: 0.25rem;
  height: 2rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.sidebar-container.minimized .sidebar-shops:before {
  display: none;
}
.sidebar-container.minimized .sidebar-shops-dropdown {
  left: calc(100% + 0.5rem);
  bottom: 0;
}
.sidebar-container.minimized .sidebar-shops-dropdown > div > div {
  width: 100%;
  display: flex;
}
.sidebar-container.minimized .sidebar-shops-dropdown > div > div:hover {
  background: var(--white);
  border-radius: 0.25rem;
}
.sidebar-container.minimized .sidebar-shops-dropdown > div > div > img {
  border-radius: 2px;
  min-width: 1.5rem !important;
  height: 1.5rem !important;
}
.sidebar-container.minimized .sidebar-shops-dropdown > div > div > i {
  border-radius: 2px;
  font-size: 0.8rem;
  min-width: 1.5rem !important;
  height: 1.5rem !important;
}
.sidebar-container.minimized .sidebar-shops-current {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 0.25rem;
  align-items: center;
  justify-content: center;
}
.sidebar-container.minimized .sidebar-shops-current img, .sidebar-container.minimized .sidebar-shops-current svg {
  min-width: 1.75rem;
  width: 1.75rem !important;
  height: 1.75rem !important;
  margin-right: 0;
}
.sidebar-container.minimized .sidebar-shops-current img + div, .sidebar-container.minimized .sidebar-shops-current svg + div {
  display: none;
}

.sidebar-shops {
  width: calc(100% - 2rem);
  padding: 0.75rem 1.5rem 0.75rem 0.5rem;
  background: var(--white);
  margin: 0 auto;
  cursor: pointer;
  position: relative;
  display: flex;
  height: 3rem;
  box-shadow: 0 1px 5px -1px rgba(7, 14, 35, 0.12);
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}
.sidebar-shops:hover:before {
  transform: rotate(-90deg);
}
.sidebar-shops:before {
  transform: rotate(0deg);
  position: absolute;
  top: 50%;
  right: 0.5rem;
  display: block;
  width: 8px;
  height: 8px;
  padding: 0;
  margin-top: -4px;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 50%;
  transition: all 0.15s;
}
.sidebar-shops-current {
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
}
.sidebar-shops-current img, .sidebar-shops-current svg {
  border-radius: 6px;
  margin-right: 0.5rem;
  width: 2rem !important;
  height: 2rem !important;
  transition: width 0.15s ease 0.15s, margin-left 0.15s ease 0.15s;
}
.sidebar-shops-current span {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--black3);
}
.sidebar-shops-current-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.sidebar-shops-current-data span {
  overflow: hidden;
  width: 125px;
  text-overflow: ellipsis;
}
.sidebar-shops-name {
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: var(--black9);
}
.sidebar-shops.open:before {
  transform: rotate(-180deg);
}
.sidebar-shops.open .sidebar-shops-dropdown {
  display: flex;
}
.sidebar-shops-dropdown {
  display: none;
  position: absolute;
  flex-direction: column;
  background: var(--white);
  box-shadow: 0 4px 24px -4px rgba(7, 14, 35, 0.08);
  left: 0;
  bottom: calc(100% + 0.5rem);
  border-radius: 0.5rem;
  z-index: 2;
  width: 100%;
  overflow: hidden;
  min-width: 208px;
}
.sidebar-shops-dropdown-body {
  display: flex;
  position: relative;
  padding: 0.5rem;
  flex-direction: column;
  cursor: pointer;
}
.sidebar-shops-dropdown-body-item {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  cursor: pointer;
}
.sidebar-shops-dropdown-body-item:hover {
  background: var(--black0) !important;
  border-radius: 0.25rem !important;
  transition: all 0.25s ease !important;
}
.sidebar-shops-dropdown-body-item:hover span {
  transition: all 0.25s ease;
  color: var(--black9);
}
.sidebar-shops-dropdown-body-item:last-child {
  margin-bottom: 0;
}
.sidebar-shops-dropdown-body-item-img {
  min-width: 1.5rem;
  width: 1.5rem !important;
  height: 1.5rem !important;
  border-radius: 6px;
  background: var(--black1);
  overflow: hidden;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--black5);
}
.sidebar-shops-dropdown-body-item-img svg {
  transform: scale(0.765);
}
.sidebar-shops-dropdown-body-item-img img {
  width: 100%;
}
.sidebar-shops-dropdown-body-item span {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--black5);
}
.sidebar-shops-dropdown-footer {
  display: flex;
  position: relative;
  flex-direction: column;
  padding: 0.5rem;
  border-top: 1px solid var(--black1);
}
.sidebar-shops-dropdown-footer-item {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  cursor: pointer;
}
.sidebar-shops-dropdown-footer-item:not(:last-child) {
  border-bottom: 1px dotted var(--black2);
}
.sidebar-shops-dropdown-footer-item:hover {
  background: var(--black0) !important;
  border-radius: 0.25rem !important;
  transition: all 0.25s ease !important;
}
.sidebar-shops-dropdown-footer-item:hover span {
  transition: all 0.25s ease;
  color: var(--black9);
}
.sidebar-shops-dropdown-footer-item svg {
  min-width: 1rem;
  width: 1rem !important;
  height: 1rem !important;
  color: var(--black5);
}
.sidebar-shops-dropdown-footer-item span {
  margin-left: 1rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--black5);
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/layouts/dashboard/sidebar/shops-dropdown.scss"],"names":[],"mappings":"AAEE;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAGI;EACE,aAAA;AADN;AAII;EACE,yBAAA;EACA,SAAA;AAFN;AAMQ;EACE,WAAA;EACA,aAAA;AAJV;AAMU;EACE,wBAAA;EACA,sBAAA;AAJZ;AAOU;EACE,kBAAA;EACA,4BAAA;EACA,yBAAA;AALZ;AAOU;EACE,kBAAA;EACA,iBAAA;EACA,4BAAA;EACA,yBAAA;AALZ;AAWI;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AATN;AAWM;EACE,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;AATR;AAWQ;EACE,aAAA;AATV;;AAkBA;EACE,wBAAA;EACA,sCAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,gDAAA;EACA,qBAAA;EACA,mBAAA;AAfF;AAkBI;EACE,yBAAA;AAhBN;AAoBE;EACE,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,qBAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAnBJ;AAqBI;EACE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gEAAA;AAnBN;AAuBI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AArBN;AAwBI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAtBN;AAwBM;EACE,gBAAA;EACA,YAAA;EACA,uBAAA;AAtBR;AA2BE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAzBJ;AA8BI;EACE,0BAAA;AA5BN;AA+BI;EACE,aAAA;AA7BN;AAiCE;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,iDAAA;EACA,OAAA;EACA,2BAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AA/BJ;AAiCI;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;AA/BN;AAiCM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AA/BR;AAiCQ;EACE,oCAAA;EACA,iCAAA;EACA,qCAAA;AA/BV;AAiCU;EACE,0BAAA;EACA,oBAAA;AA/BZ;AAmCQ;EACE,gBAAA;AAjCV;AAoCQ;EACE,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AAlCV;AAoCU;EACE,uBAAA;AAlCZ;AAqCU;EACE,WAAA;AAnCZ;AAuCQ;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AArCV;AA2CI;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,mCAAA;AAzCN;AA2CM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAzCR;AA2CQ;EACE,uCAAA;AAzCV;AA4CQ;EACE,oCAAA;EACA,iCAAA;EACA,qCAAA;AA1CV;AA4CU;EACE,0BAAA;EACA,oBAAA;AA1CZ;AA8CQ;EACE,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;AA5CV;AA+CQ;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AA7CV","sourcesContent":[".sidebar-container.minimized  {\n\n  .sidebar-shops {\n    width: 2rem;\n    padding: 0.25rem;\n    height: 2rem;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n\n    &:before {\n      display: none;\n    };\n\n    &-dropdown {\n      left: calc(100% + .5rem);\n      bottom: 0;\n\n      & > div {\n\n        & > div {\n          width: 100%;\n          display: flex;\n\n          &:hover {\n            background: var(--white);\n            border-radius: .25rem;\n          }\n\n          & > img {\n            border-radius: 2px;\n            min-width: 1.5rem !important;\n            height: 1.5rem !important;\n          }\n          & > i {\n            border-radius: 2px;\n            font-size: .8rem;\n            min-width: 1.5rem !important;\n            height: 1.5rem !important;\n          }\n        }\n      }\n    }\n\n    &-current {\n      display: flex;\n      width: 100%;\n      height: 100%;\n      padding: 0.25rem;\n      align-items: center;\n      justify-content: center;\n\n      img, svg {\n        min-width: 1.75rem;\n        width: 1.75rem !important;\n        height: 1.75rem !important;\n        margin-right: 0;\n\n        + div {\n          display: none;\n        }\n      }\n\n    }\n  }\n\n};\n\n.sidebar-shops {\n  width: calc(100% - 2rem);\n  padding: 0.75rem 1.5rem 0.75rem 0.5rem;\n  background: var(--white);\n  margin: 0 auto;\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  height: 3rem;\n  box-shadow: 0 1px 5px -1px rgb(7 14 35 / 12%);\n  border-radius: .5rem;\n  margin-bottom: 1rem;\n\n  &:hover {\n    &:before {\n      transform: rotate(-90deg);\n    }\n  }\n\n  &:before {\n    transform: rotate(0deg);\n    position: absolute;\n    top: 50%;\n    right: .5rem;\n    display: block;\n    width: 8px;\n    height: 8px;\n    padding: 0;\n    margin-top: -4px;\n    content: \"\";\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' width='16' height='16'%3e%3cg%3e%3cpolygon fill='%23A2AAB4' points='11.06 5.72666667 8 8.78 4.94 5.72666667 4 6.66666667 8 10.6666667 12 6.66666667'%3e%3c/polygon%3e%3c/g%3e%3c/svg%3e \");\n    background-repeat: no-repeat;\n    background-position: 50%;\n    transition: all .15s;\n  }\n\n  &-current {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    cursor: pointer;\n\n    img, svg {\n      border-radius: 6px;\n      margin-right: .5rem;\n      width: 2rem !important;\n      height: 2rem !important;\n      transition: width .15s ease .15s,  margin-left .15s ease .15s;\n    }\n\n\n    span {\n      font-style: normal;\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 15px;\n      color: var(--black3);\n    }\n\n    &-data {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n\n      span {\n        overflow: hidden;\n        width: 125px;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  &-name {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 16px;\n    color: var(--black9);\n  }\n\n  &.open {\n\n    &:before {\n      transform: rotate(-180deg);\n    }\n\n    .sidebar-shops-dropdown {\n      display: flex;\n    }\n  }\n\n  &-dropdown {\n    display: none;\n    position: absolute;\n    flex-direction: column;\n    background: var(--white);\n    box-shadow: 0 4px 24px -4px rgba(7, 14, 35, 0.08);\n    left: 0;\n    bottom: calc(100% + 0.5rem);\n    border-radius: .5rem;\n    z-index: 2;\n    width: 100%;\n    overflow: hidden;\n    min-width: 208px;\n\n    &-body {\n      display: flex;\n      position: relative;\n      padding: .5rem;\n      flex-direction: column;\n      cursor: pointer;\n\n      &-item {\n        display: flex;\n        align-items: center;\n        padding: .5rem;\n        cursor: pointer;\n\n        &:hover {\n          background: var(--black0) !important;\n          border-radius: .25rem !important;\n          transition: all .25s ease !important;\n\n          span {\n            transition: all .25s ease;\n            color: var(--black9);\n          }\n        }\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n\n        &-img {\n          min-width: 1.5rem;\n          width: 1.5rem !important;\n          height: 1.5rem !important;\n          border-radius: 6px;\n          background: var(--black1);\n          overflow: hidden;\n          margin-right: 10px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          color: var(--black5);\n\n          svg {\n            transform: scale(.765);\n          }\n\n          img {\n            width: 100%;\n          }\n        }\n\n        span {\n          font-family: 'Inter';\n          font-style: normal;\n          font-weight: 500;\n          font-size: 14px;\n          line-height: 17px;\n          color: var(--black5);\n        }\n      }\n\n    }\n\n    &-footer {\n      display: flex;\n      position: relative;\n      flex-direction: column;\n      padding: .5rem;\n      border-top: 1px solid var(--black1);\n\n      &-item {\n        display: flex;\n        align-items: center;\n        padding: .5rem;\n        cursor: pointer;\n\n        &:not(:last-child) {\n          border-bottom: 1px dotted var(--black2);\n        }\n\n        &:hover {\n          background: var(--black0) !important;\n          border-radius: .25rem !important;\n          transition: all .25s ease !important;\n\n          span {\n            transition: all .25s ease;\n            color: var(--black9);\n          }\n        }\n\n        svg {\n          min-width: 1rem;\n          width: 1rem !important;\n          height: 1rem !important;\n          color: var(--black5);\n        }\n\n        span {\n          margin-left: 1rem;\n          font-family: 'Inter';\n          font-style: normal;\n          font-weight: 500;\n          font-size: 14px;\n          line-height: 17px;\n          color: var(--black5);\n        }\n      }\n    }\n  }\n\n};\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
